export function copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
        console.log('Content copied to clipboard');
    },() => {
    });
}
export function showMessage(message, type='alert-success') {
    let messageContainer = $(`[data-floating-error-container]`);

    if (type === 'error') {
        type = 'alert-danger';
    }

    let markup = `<div class="alert ${type} col-12 col-md-6 text-center justify-content-between align-items-center fade show m-0 slide-from-left" style="display: flex; border-radius: 50px; padding: 7px 10px">
            <button type="button" class="btn-close position-static opacity-0 pe-none" data-bs-dismiss="alert" aria-label="Close"></button>
            <div>${message}</div>
            <button type="button" class="btn btn-clear position-static pe-2 py-0 d-flex" style="scale: 1.2;opacity: .6; color: var(--bs-btn-hover-color);" data-bs-dismiss="alert" aria-label="Close">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>`;

    let el = $(markup);
    messageContainer.append(el);

    setTimeout(() => {
        el.fadeOut(1000);
    }, 5000)
}
